import { render, staticRenderFns } from "./generator.user.profile.link.vue?vue&type=template&id=0dd7790a&"
import script from "./generator.user.profile.link.vue?vue&type=script&lang=ts&"
export * from "./generator.user.profile.link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports